import React, { useEffect, useState } from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import IconButton from '@material-ui/core/IconButton';
import withStyles from '@material-ui/core/styles/withStyles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import TradePlanUserPreferencesMenu from './userprefs/tradeplanuserprefs/TradePlanUserPreferencesMenu';
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';
import { Collapse, Tooltip } from '@material-ui/core';
import List from '@material-ui/core/List';
import QuickTradeUserPreferencesMenu from './userprefs/quicktradesuserprefs/QuickTradeUserPreferencesMenu';
import MessageCenter from './messages/MessageCenter';
import isEmpty from '../../../utils/objectchecking/IsEmpty';
import UserAlertsPreferences from './userprefs/useralertsuserprefs/UserAlertsPreferences';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import { colors } from '../../../colorVars';
import { ChangePasswordForm } from '../../forms/auth/ChangePasswordForm';
import { Dialog, DialogContent, DialogTitle, IconButton as MuiIconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { isOptionInstrument } from '../tradeplans/activeTradePlanModule/utils/optionInstrument';

export default function Settings({ userPreferences }) {
  const { userPreferencesSubject } = useWebsocketStore();
  const [receivedUserPreferences, setReceivedPreferences] = useState(false);

  useEffect(() => {
    const subscription = userPreferencesSubject.subscribe((msg) => {
      storeUserPreferences(msg, userPreferences);
      setReceivedPreferences(true);
    });
    return () => subscription.unsubscribe();
  }, [userPreferences, userPreferencesSubject]);

  return (
    <BuildSettings
      userPreferences={userPreferences}
      receivedUserPreferences={receivedUserPreferences}
    />
  );
}
/* 
export class Settings1 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.subscription = UserPreferencesSubject.subscribe((msg) =>
      storeUserPreferences(msg, this.props.userPreferences)
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    return <BuildSettings userPreferences={this.props.userPreferences} />;
  }
} */

const storeUserPreferences = (msg, storeUserPreferences) => {

  const json = msg.json;
  if (json === null) {
    return;
  }
  const storedTradePlanConfig = json['tradePlanConfig'];
  const { tradePlanConfig, dispatchTradePlanConfig } =
    storeUserPreferences['tradePlanConfig'];

  const compareTpConfigFields = (incomingField, storedField, fieldName) => {
    if (incomingField !== storedField && incomingField !== undefined) {
      dispatchTradePlanConfig({ [fieldName]: incomingField });
    }
  };
  if (storedTradePlanConfig !== undefined) {
    compareTpConfigFields(
      storedTradePlanConfig.dataSource,
      tradePlanConfig.dataSource,
      'dataSource'
    );
    compareTpConfigFields(
      storedTradePlanConfig.brokerage,
      tradePlanConfig.brokerage,
      'brokerage'
    );
    compareTpConfigFields(
      storedTradePlanConfig.flattenAtMarketClose,
      tradePlanConfig.flattenAtMarketClose,
      'flattenAtMarketClose'
    );
    compareTpConfigFields(
      storedTradePlanConfig.accountNumber,
      tradePlanConfig.accountNumber,
      'accountNumber'
    );
    compareTpConfigFields(
      storedTradePlanConfig.workOrders,
      tradePlanConfig.workOrders,
      'workOrders'
    );
    compareTpConfigFields(
      storedTradePlanConfig.workOrdersOnEntry,
      tradePlanConfig.workOrdersOnEntry,
      'workOrdersOnEntry'
    );
    compareTpConfigFields(
      storedTradePlanConfig.workOrdersOnExit,
      tradePlanConfig.workOrdersOnExit,
      'workOrdersOnExit'
    );
    compareTpConfigFields(
      storedTradePlanConfig.quantityBasis,
      tradePlanConfig.quantityBasis,
      'quantityBasis'
    );
    compareTpConfigFields(
      storedTradePlanConfig.instrument,
      tradePlanConfig.instrument,
      'instrument'
    );
    compareTpConfigFields(
      storedTradePlanConfig.getAwayOffsetPct,
      tradePlanConfig.getAwayOffsetPct,
      'getAwayOffsetPct'
    );
    compareTpConfigFields(
      storedTradePlanConfig.pctBetweenBidAsk,
      tradePlanConfig.pctBetweenBidAsk,
      'pctBetweenBidAsk'
    );
    compareTpConfigFields(
      storedTradePlanConfig.pctIncreasePerOrderAttempt,
      tradePlanConfig.pctIncreasePerOrderAttempt,
      'pctIncreasePerOrderAttempt'
    );

    compareTpConfigFields(
      storedTradePlanConfig.useDifferentWorkOrderFieldsOnExit,
      tradePlanConfig.useDifferentWorkOrderFieldsOnExit,
      'useDifferentWorkOrderFieldsOnExit'
    );

    compareTpConfigFields(
      storedTradePlanConfig.getAwayOffsetPctOnExit,
      tradePlanConfig.getAwayOffsetPctOnExit,
      'getAwayOffsetPctOnExit'
    );

    compareTpConfigFields(
      storedTradePlanConfig.pctBetweenBidAskOnExit,
      tradePlanConfig.pctBetweenBidAskOnExit,
      'pctBetweenBidAskOnExit'
    );

    compareTpConfigFields(
      storedTradePlanConfig.pctIncreasePerOrderAttemptOnExit,
      tradePlanConfig.pctIncreasePerOrderAttemptOnExit,
      'pctIncreasePerOrderAttemptOnExit'
    );

    //target
    compareTpConfigFields(
      storedTradePlanConfig.useDifferentWorkOrderFieldsOnTarget,
      tradePlanConfig.useDifferentWorkOrderFieldsOnTarget,
      'useDifferentWorkOrderFieldsOnTarget'
    );

    compareTpConfigFields(
      storedTradePlanConfig.getAwayOffsetPctOnTarget,
      tradePlanConfig.getAwayOffsetPctOnTarget,
      'getAwayOffsetPctOnTarget'
    );

    compareTpConfigFields(
      storedTradePlanConfig.pctBetweenBidAskOnTarget,
      tradePlanConfig.pctBetweenBidAskOnTarget,
      'pctBetweenBidAskOnTarget'
    );

    compareTpConfigFields(
      storedTradePlanConfig.pctIncreasePerOrderAttemptOnTarget,
      tradePlanConfig.pctIncreasePerOrderAttemptOnTarget,
      'pctIncreasePerOrderAttemptOnTarget'
    );
    //console.log(storedTradePlanConfig);
    //console.log(tradePlanConfig);
    compareTpConfigFields(
      storedTradePlanConfig.evaluateQuotes,
      tradePlanConfig.evaluateQuotes,
      'evaluateQuotes'
    );
    //console.log(storedTradePlanConfig);
    //console.log(tradePlanConfig);
    compareTpConfigFields(
      storedTradePlanConfig.persistTradePlanOnFailedFiltersOrValidation,
      tradePlanConfig.persistTradePlanOnFailedFiltersOrValidation,
      'persistTradePlanOnFailedFiltersOrValidation'
    );
  }

  const storedDefaultOptionRadio = msg['json'][
    'optionRadioButtons'
  ];
  const { defaultOptionRadio, setDefaultOptionRadio } =
    storeUserPreferences['optionRadioButtons'];
  // console.log("storedDefaultOptionRadio: " + storedDefaultOptionRadio);
  if (storedDefaultOptionRadio !== undefined) {
    if (storedDefaultOptionRadio !== defaultOptionRadio) {
      setDefaultOptionRadio(storedDefaultOptionRadio);
    }
  }

  const storedDefaultSavedConfigKey = msg['json'][
    'defaultSavedTpConfigKey'
  ];
  const { savedConfigKey, setSavedConfigKey } =
    storeUserPreferences['defaultSavedTpConfigKey'];
  if (storedDefaultSavedConfigKey !== undefined) {
    if (savedConfigKey !== storedDefaultSavedConfigKey) {
      setSavedConfigKey(storedDefaultSavedConfigKey);
    }
  }

  const storedOptionsManagement = msg['json']['optionManagement'];
  const [
    tightSpreadPctEnabled,
    setTightSpreadPctEnabled,
    tightSpreadCentsEnabled,
    setTightSpreadCentsEnabled,
    optionPriceRangeEnabled,
    setOptionPriceRangeEnabled,
    tightSpreadPct,
    dispatchTightSpreadPct,
    tightSpreadCents,
    dispatchTightSpreadCents,
    optionPriceRange,
    dispatchOptionPriceRange,
    qtyRangeEnabled,
    setQtyRangeEnabled,
    dollarRangeEnabled,
    setDollarRangeEnabled,
    qtyRange,
    dispatchQtyRange,
    dollarRange,
    dispatchDollarRange,
    hugCurrentPriceEnabled,
    setHugCurrentPriceEnabled,
    hugCurrentPrice,
    dispatchHugCurrentPrice,
    setViewOptionManagementEnabled,
    expirationDates,
    setExpirationDates, //expiration dates are irrelevant I think here
    buyOrSellOption,
    setBuyOrSellOption,
    otm,
    setOtm,
    itm,
    setItm,
    notExpiringToday,
    setNotExpiringToday,
    {},
    {}, //empty options bc irrelavent. the rest are empty functions/json to be able to reuse components
    {}, //set option choices
    {}, //option chain
    {}, //set option chain
    {}, //symbols used
    {}, //set symbols used
    otm1Enabled,
    setOtm1Enabled,
    otm1,
    dispatchOtm1,
    itm1Enabled,
    setItm1Enabled,
    itm1,
    dispatchItm1,
  ] = storeUserPreferences['optionManagement']['tpConfigOptionManagement'];

  if (
    storedTradePlanConfig !== undefined &&
    isOptionInstrument(storedTradePlanConfig.instrument)
  ) {
    setViewOptionManagementEnabled(true);
  }
  const compareOptionManagementStates = (
    incomingOptionState,
    currentOptionState,
    setOptionEnabled,
    dispatchOptionParam
  ) => {
    if (
      incomingOptionState !== undefined &&
      (currentOptionState === undefined ||
        JSON.stringify(incomingOptionState) !==
          JSON.stringify(currentOptionState))
    ) {
      setOptionEnabled(true);
      dispatchOptionParam(incomingOptionState);
    }
  };

  const compareOptionFields = (incomingField, currentField, setter) => {
    if (incomingField !== currentField) {
      setter(incomingField);
    }
  };

  if (storedOptionsManagement !== undefined) {
    if (
      storedOptionsManagement['optionFilters'] !== undefined &&
      storedOptionsManagement['optionFilters'] !== null
    ) {
      if (storedOptionsManagement['optionFilters']['tightSpreadPct']) {
        compareOptionManagementStates(
          storedOptionsManagement['optionFilters']['tightSpreadPct'],
          tightSpreadPct,
          setTightSpreadPctEnabled,
          dispatchTightSpreadPct
        );
      } else {
        setTightSpreadPctEnabled(false);
      }
      compareOptionManagementStates(
        storedOptionsManagement['optionFilters']['tightSpreadCents'],
        tightSpreadCents,
        setTightSpreadCentsEnabled,
        dispatchTightSpreadCents
      );
      compareOptionManagementStates(
        storedOptionsManagement['optionFilters']['optionPriceRange'],
        optionPriceRange,
        setOptionPriceRangeEnabled,
        dispatchOptionPriceRange
      );
      compareOptionManagementStates(
        storedOptionsManagement['optionFilters']['qtyRange'],
        qtyRange,
        setQtyRangeEnabled,
        dispatchQtyRange
      );
      compareOptionManagementStates(
        storedOptionsManagement['optionFilters']['dollarRange'],
        dollarRange,
        setDollarRangeEnabled,
        dispatchDollarRange
      );
    }
    if (storedOptionsManagement['optionChainStrategy'] !== undefined) {
      compareOptionManagementStates(
        storedOptionsManagement['optionChainStrategy']['hugCurrentPrice'],
        hugCurrentPrice,
        setHugCurrentPriceEnabled,
        dispatchHugCurrentPrice
      );

      if (
        storedOptionsManagement['optionChainStrategy']['ITM1'] !== undefined &&
        (itm1 === undefined ||
          storedOptionsManagement['optionChainStrategy']['ITM1']) !==
          JSON.stringify(itm1)
      ) {
        setItm1Enabled(true);
        setHugCurrentPriceEnabled(false);
        dispatchItm1(storedOptionsManagement['optionChainStrategy']['ITM1']);
      }

      if (
        storedOptionsManagement['optionChainStrategy']['OTM1'] !== undefined &&
        (otm1 === undefined ||
          storedOptionsManagement['optionChainStrategy']['OTM1']) !==
          JSON.stringify(otm1)
      ) {
        setOtm1Enabled(true);
        setHugCurrentPriceEnabled(false);
        dispatchOtm1(storedOptionsManagement['optionChainStrategy']['OTM1']);
      }
    }

    compareOptionFields(storedOptionsManagement['OTM'], otm, setOtm);
    compareOptionFields(storedOptionsManagement['ITM'], itm, setItm);
    compareOptionFields(
      storedOptionsManagement['buyOrSellOption'],
      buyOrSellOption,
      setBuyOrSellOption
    );
    compareOptionFields(
      storedOptionsManagement['notExpiringToday'],
      notExpiringToday,
      setNotExpiringToday
    );
  }

  const entryTacticsConfig = msg['json'][
    'tradePlanDefaultEntryTactics'
  ];

  const {
    marketOrderEnabled,
    setMarketOrderEnabled,
    limitOrderEnabled,
    setLimitOrderEnabled,
    limitOrderOffsetAmount,
    setLimitOrderOffsetAmount,
    setLimitFromSetupBreakPrice,
    setSetLimitFromSetupBreakPrice,
    candleBreakEnabled,
    setCandleBreakEnabled,
    candleBreakCandleDuration,
    setCandleBreakCandleDuration,
    waitUntilCurrentCandleCloses,
    setWaitUntilCurrentCandleCloses,
    breakBy,
    setBreakBy,
    dollarStock,
    setDollarStock,
    dollarOption,
    setDollarOption,
    qtyStock,
    setQtyStock,
    qtyOption,
    setQtyOption,
  } = storeUserPreferences['tradePlanDefaultEntryTactics'];

  if (entryTacticsConfig !== undefined) {
    if (entryTacticsConfig['qtyBasisValues'] !== undefined) {
      if (
        entryTacticsConfig['qtyBasisValues']['dollarStock'] !== undefined &&
        entryTacticsConfig['qtyBasisValues']['dollarStock'] !== dollarStock
      ) {
        setDollarStock(entryTacticsConfig['qtyBasisValues']['dollarStock']);
      }
      if (
        entryTacticsConfig['qtyBasisValues']['dollarOption'] !== undefined &&
        entryTacticsConfig['qtyBasisValues']['dollarOption'] !== dollarOption
      ) {
        setDollarOption(entryTacticsConfig['qtyBasisValues']['dollarOption']);
      }
      if (
        entryTacticsConfig['qtyBasisValues']['qtyStock'] !== undefined &&
        entryTacticsConfig['qtyBasisValues']['qtyStock'] !== qtyStock
      ) {
        setQtyStock(entryTacticsConfig['qtyBasisValues']['qtyStock']);
      }
      if (
        entryTacticsConfig['qtyBasisValues']['qtyOption'] !== undefined &&
        entryTacticsConfig['qtyBasisValues']['qtyOption'] !== qtyOption
      ) {
        setQtyOption(entryTacticsConfig['qtyBasisValues']['qtyOption']);
      }
    }
    if (
      entryTacticsConfig['marketOrder'] !== undefined &&
      entryTacticsConfig['marketOrder']['enabled']
    ) {
      if (marketOrderEnabled !== entryTacticsConfig['marketOrder']['enabled']) {
        setMarketOrderEnabled(true);
      }
    } else {
      setMarketOrderEnabled(false);
    }
    if (
      entryTacticsConfig['limitOrder'] !== undefined &&
      entryTacticsConfig['limitOrder']['offset']
    ) {
      if (limitOrderEnabled !== entryTacticsConfig['limitOrder']['enabled']) {
        setLimitOrderEnabled(true);
      }
      if (
        limitOrderOffsetAmount !== entryTacticsConfig['limitOrder']['offset']
      ) {
        if (entryTacticsConfig['limitOrder']['offset'] !== undefined) {
          setLimitOrderOffsetAmount(entryTacticsConfig['limitOrder']['offset']);
        }
      }
      if (
        setLimitFromSetupBreakPrice !==
        entryTacticsConfig['limitOrder']['setLimitFromSetupBreakPrice']
      ) {
        if (
          entryTacticsConfig['limitOrder']['setLimitFromSetupBreakPrice'] !==
          undefined
        ) {
          setSetLimitFromSetupBreakPrice(
            entryTacticsConfig['limitOrder']['setLimitFromSetupBreakPrice']
          );
        }
      }
    } else {
      setLimitOrderEnabled(false);
    }
    if (
      entryTacticsConfig['candleBreak'] !== undefined &&
      entryTacticsConfig['candleBreak']['enabled']
    ) {
      if (candleBreakEnabled !== entryTacticsConfig['candleBreak']['enabled']) {
        setCandleBreakEnabled(true);
      }
    }
    if (
      candleBreakCandleDuration !==
      entryTacticsConfig['candleBreak']['candleDuration']
    ) {
      if (entryTacticsConfig['candleBreak']['candleDuration'] !== undefined) {
        setCandleBreakCandleDuration(
          entryTacticsConfig['candleBreak']['candleDuration']
        );
      }
    }
    if (
      waitUntilCurrentCandleCloses !==
      entryTacticsConfig['candleBreak']['waitUntilCurrentCandleCloses']
    ) {
      if (
        entryTacticsConfig['candleBreak']['waitUntilCurrentCandleCloses'] !==
        undefined
      ) {
        setWaitUntilCurrentCandleCloses(
          entryTacticsConfig['candleBreak']['waitUntilCurrentCandleCloses']
        );
      }
    }
    if (breakBy !== entryTacticsConfig['candleBreak']['breakBy']) {
      if (entryTacticsConfig['candleBreak']['breakBy'] !== undefined) {
        setBreakBy(entryTacticsConfig['candleBreak']['breakBy']);
      }
    }
  } else {
    setCandleBreakEnabled(false);
  }

  let exitTactics = msg['json']['exitTactics'];
  // let currentUserPreferences = storeUserPreferences["userPreferences"];
  const {
    lossLimit,
    dispatchLossLimit,
    lossLimitEnabled,
    setLossLimitEnabled,
    preserveProfit,
    dispatchPreserveProfit,
    preserveProfitEnabled,
    setPreserveProfitEnabled,
    positionPriceTrail,
    dispatchPositionPriceTrail,
    positionPriceTrailEnabled,
    setPositionPriceTrailEnabled,
    underlyingPriceTrail,
    dispatchUnderlyingPriceTrail,
    underlyingPriceTrailEnabled,
    setUnderlyingPriceTrailEnabled,
    candleTrail,
    dispatchCandleTrail,
    candleTrailEnabled,
    setCandleTrailEnabled,
    grabCents,
    dispatchGrabCents,
    grabCentsEnabled,
    setGrabCentsEnabled,
    grabCentsMode,
    setGrabCentsMode,
    greenToRedCandles,
    dispatchGreenToRedCandles,
    greenToRedCandlesEnabled,
    setGreenToRedCandlesEnabled,
    greenToRedPositions,
    dispatchGreenToRedPositions,
    greenToRedPositionsEnabled,
    setGreenToRedPositionsEnabled,
    breakPrice,
    dispatchBreakPrice,
    breakPriceEnabled,
    setBreakPriceEnabled,
    positionBreakPrice,
    dispatchPositionBreakPrice,
    positionBreakPriceEnabled,
    setPositionBreakPriceEnabled,
    candleMagnitude,
    dispatchCandleMagnitude,
    candleMagnitudeEnabled,
    setCandleMagnitudeEnabled,
    ratchetBracket,
    dispatchRatchetBracket,
    ratchetBracketEnabled,
    setRatchetBracketEnabled,
    atrTrailEnabled,
    setAtrTrailEnabled,
    atrTrail,
    dispatchAtrTrail,
    mfeRetracementEnabled,
    setMfeRetracementEnabled,
    mfeRetracement,
    dispatchMfeRetracement,
    underlyingPriceExitEnabled,
    setUnderlyingPriceExitEnabled,
    underlyingPriceExit,
    dispatchUnderlyingPriceExit,
  } = storeUserPreferences['exitTactics'];

  const comparePreferenceTacticStates = (
    incomingTactic,
    oldTactic,
    setTacticEnabled,
    dispatchTactic
  ) => {
    //console.log(incomingTactic);
    //console.log(oldTactic);
    if (
      incomingTactic !== undefined //&&
      //    (oldTactic === undefined || (JSON.stringify(oldTactic) !== JSON.stringify(incomingTactic)))
    ) {
      setTacticEnabled(true);
      //console.log(incomingTactic);
      dispatchTactic(incomingTactic);
    }
  };

  if (exitTactics !== undefined) {
    comparePreferenceTacticStates(
      exitTactics.LOSS_LIMIT,
      lossLimit,
      setLossLimitEnabled,
      dispatchLossLimit
    );
    comparePreferenceTacticStates(
      exitTactics.PRESERVE_PROFIT,
      preserveProfit,
      setPreserveProfitEnabled,
      dispatchPreserveProfit
    );
    comparePreferenceTacticStates(
      exitTactics.POSITION_PRICE_TRAIL,
      positionPriceTrail,
      setPositionPriceTrailEnabled,
      dispatchPositionPriceTrail
    );
    comparePreferenceTacticStates(
      exitTactics.UNDERLYING_PRICE_TRAIL,
      underlyingPriceTrail,
      setUnderlyingPriceTrailEnabled,
      dispatchUnderlyingPriceTrail
    );
    comparePreferenceTacticStates(
      exitTactics.CANDLE_TRAIL,
      candleTrail,
      setCandleTrailEnabled,
      dispatchCandleTrail
    );
    comparePreferenceTacticStates(
      exitTactics.ATR_TRAIL,
      atrTrail,
      setAtrTrailEnabled,
      dispatchAtrTrail
    );
    comparePreferenceTacticStates(
      exitTactics.MFE_RETRACEMENT,
      mfeRetracement,
      setMfeRetracementEnabled,
      dispatchMfeRetracement
    );
    comparePreferenceTacticStates(
      exitTactics.UNDERLYING_PRICE_EXIT,
      underlyingPriceExit,
      setUnderlyingPriceExitEnabled,
      dispatchUnderlyingPriceExit
    );
    /*if (exitTactics.GRAB_CENTS !== undefined) {
            setGrabCentsEnabled(true);
            //console.log(incomingTactic);
            let gc = exitTactics.GRAB_CENTS;
            //let deepCopy = {};
            //Object.keys(key => deepCopy[key] = gc[key]);
            //console.log(gc.percentagePerLevel);
            let deepCopy = {};
            Object.keys(exitTactics.GRAB_CENTS).forEach(key => deepCopy[key] = gc[key]);
            if (!isEmpty(deepCopy.percentagePerLevel)) {
                let pctArray = [];
                setGrabCentsMode("percentage");
                let pctPerLevels = deepCopy.percentagePerLevel;
                //console.log(pctPerLevels);
                for (let index in pctPerLevels) {
                    //console.log(index);
                    let pct = pctPerLevels[index];
                    //console.log(pct);
                    pctArray.push(pct * 100);
                }
                deepCopy.percentagePerLevel = pctArray;
            }
            if (!isEmpty(deepCopy.quantityPerLevel)) {
                setGrabCentsMode("quantity");
            }
            //console.log(gc.percentagePerLevel);
            dispatchGrabCents(deepCopy);
        }*/
    comparePreferenceTacticStates(
      exitTactics.GRAB_CENTS,
      grabCents,
      setGrabCentsEnabled,
      dispatchGrabCents
    );
    if (exitTactics.GRAB_CENTS !== undefined) {
      let gc = exitTactics.GRAB_CENTS;
      if (!gc.takeProfitMode) {
        gc.takeProfitMode = 'DOLLARS';
        dispatchGrabCents({ takeProfitMode: gc.takeProfitMode });
      }
      if (!isEmpty(gc.quantityPerLevel)) {
        setGrabCentsMode('quantity');
      }
      if (!isEmpty(gc.percentagePerLevel)) {
        setGrabCentsMode('percentage');
      }
    }
    comparePreferenceTacticStates(
      exitTactics.GREEN_TO_RED_CANDLES,
      greenToRedCandles,
      setGreenToRedCandlesEnabled,
      dispatchGreenToRedCandles
    );
    comparePreferenceTacticStates(
      exitTactics.GREEN_TO_RED_POSITIONS,
      greenToRedPositions,
      setGreenToRedPositionsEnabled,
      dispatchGreenToRedPositions
    );
    comparePreferenceTacticStates(
      exitTactics.BREAK_PRICE,
      breakPrice,
      setBreakPriceEnabled,
      dispatchBreakPrice
    );
    comparePreferenceTacticStates(
      exitTactics.POSITION_BREAK_PRICE,
      positionBreakPrice,
      setPositionBreakPriceEnabled,
      dispatchPositionBreakPrice
    );
    comparePreferenceTacticStates(
      exitTactics.CANDLE_MAGNITUDE,
      candleMagnitude,
      setCandleMagnitudeEnabled,
      dispatchCandleMagnitude
    );
    comparePreferenceTacticStates(
      exitTactics.RATCHET_BRACKET,
      ratchetBracket,
      setRatchetBracketEnabled,
      dispatchRatchetBracket
    );
  }

  const quickTrade = msg['json']['quickTrade'];

  const {
    instrument,
    setInstrument,
    quantityBasis,
    setQuantityBasis,
    quantityBasisValue,
    setQuantityBasisValue,
    accountNumber,
    setAccountNumber,
    dataSource,
    setDataSource,
    brokerage,
    setBrokerage,
    optionDirection,
    setOptionDirection,
    entryType,
    setEntryType,
    limitOrder,
    dispatchLimitOrder,
    candleBreak,
    dispatchCandleBreak,
    Break,
    dispatchBreak,
    nearestOtmItm,
    setNearestOtmItm,
    maxOptionPrice,
    setMaxOptionPrice,
    expirationWeeksAway,
    setExpirationWeeksAway,
    optionNotExpiringToday,
    setOptionNotExpiringToday,
    workOrder,
    setWorkOrder,
    pctIncreasePerOrderAttempt,
    setPctIncreasePerOrderAttempt,
    pctBetweenBidAsk,
    setPctBetweenBidAsk,
    getAwayOffsetPct,
    setGetAwayOffsetPct,
  } = storeUserPreferences['quickTrade'];

  const compareQuickTradeStates = (incomingSetting, oldSetting, setSetting) => {
    if (
      incomingSetting !== undefined &&
      (oldSetting === undefined ||
        JSON.stringify(incomingSetting) !== JSON.stringify(oldSetting))
    ) {
      setSetting(incomingSetting);
    }
  };
  if (quickTrade !== undefined) {
    compareQuickTradeStates(quickTrade.instrument, instrument, setInstrument);
    compareQuickTradeStates(
      quickTrade.quantityBasis,
      quantityBasis,
      setQuantityBasis
    );
    compareQuickTradeStates(
      quickTrade.quantityBasisValue,
      quantityBasisValue,
      setQuantityBasisValue
    );
    compareQuickTradeStates(
      quickTrade.accountNumber,
      accountNumber,
      setAccountNumber
    );
    compareQuickTradeStates(quickTrade.dataSource, dataSource, setDataSource);
    compareQuickTradeStates(quickTrade.brokerage, brokerage, setBrokerage);
    compareQuickTradeStates(
      quickTrade.optionDirection,
      optionDirection,
      setOptionDirection
    );
    compareQuickTradeStates(quickTrade.entryType, entryType, setEntryType);
    compareQuickTradeStates(
      quickTrade.nearestOtmItm,
      nearestOtmItm,
      setNearestOtmItm
    );
    compareQuickTradeStates(
      quickTrade.maxOptionPrice,
      maxOptionPrice,
      setMaxOptionPrice
    );
    compareQuickTradeStates(
      quickTrade.expirationWeeksAway,
      expirationWeeksAway,
      setExpirationWeeksAway
    );
    compareQuickTradeStates(quickTrade.workOrders, workOrder, setWorkOrder);
    compareQuickTradeStates(
      quickTrade.pctIncreasePerOrderAttempt,
      pctIncreasePerOrderAttempt,
      setPctIncreasePerOrderAttempt
    );
    compareQuickTradeStates(
      quickTrade.pctBetweenBidAsk,
      pctBetweenBidAsk,
      setPctBetweenBidAsk
    );
    compareQuickTradeStates(
      quickTrade.getAwayOffsetPct,
      getAwayOffsetPct,
      setGetAwayOffsetPct
    );
    compareQuickTradeStates(
      quickTrade.notExpiringToday,
      optionNotExpiringToday,
      setOptionNotExpiringToday
    );
    if (
      quickTrade.limitOrder !== undefined &&
      (limitOrder === undefined ||
        JSON.stringify(quickTrade.limitOrder) !== JSON.stringify(limitOrder))
    ) {
      dispatchLimitOrder(quickTrade.limitOrder);
    }
    if (
      quickTrade.candleBreak !== undefined &&
      (candleBreak === undefined ||
        JSON.stringify(quickTrade.candleBreak) !== JSON.stringify(candleBreak))
    ) {
      dispatchCandleBreak(quickTrade.candleBreak);
    }
    if (
      quickTrade['break'] !== undefined &&
      (Break === undefined ||
        JSON.stringify(quickTrade['break']) !== JSON.stringify(Break))
    ) {
      dispatchBreak(quickTrade['break']);
    }
  }
  let storedRestartSettings = msg['json']['restartSettings'];
  const { restartSettings, setRestartSettings } =
    storeUserPreferences['restartSettings'];
  if (storedRestartSettings !== undefined) {
    setRestartSettings(storedRestartSettings);
  }

  let storedUserAlerts = msg['json']['userAlerts'];
  const { userAlerts, setUserAlerts } = storeUserPreferences['userAlerts'];
  if (storedUserAlerts !== undefined) {
    setUserAlerts(storedUserAlerts);
  }
};

function BuildSettings({
  userPreferences,
  receivedUserPreferences,
  changesApplied,
  setChangesApplied,
}) {
  const popupState = usePopupState({
    variant: 'menu',
    popupId: 'Settings',
  });
  const [seeUserPreferences, setSeeUserPreferences] = React.useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);

  const handleOpenChangePassword = () => {
    setChangePasswordOpen(true);
    popupState.close(); // Close the settings menu
  };

  return (
    <>
      <Tooltip
        disableFocusListener
        disableTouchListener
        title={'open user settings'}
      >
        <IconButton style={{ padding: '0px' }} {...bindTrigger(popupState)}>
          <SettingsIcon
            style={{
              color: colors.lightGrey,
              width: 30,
              height: 30,
              padding: '0px',
            }}
          />
        </IconButton>
      </Tooltip>
      <StyledMenu
        id="customized-menu"
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
      >
        <StyledMenuItem>
          <ListItemText
            primary="User Preferences"
            onClick={() => setSeeUserPreferences(!seeUserPreferences)}
          />
          {seeUserPreferences ? <IconExpandLess /> : <IconExpandMore />}
          <Collapse in={seeUserPreferences} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <TradePlanUserPreferencesMenu
                userPreferences={userPreferences}
                receivedUserPreferences={receivedUserPreferences}
              />
              <QuickTradeUserPreferencesMenu
                userPreferences={userPreferences}
                receivedUserPreferences={receivedUserPreferences}
              />
              <UserAlertsPreferences
                userPreferences={userPreferences}
                receivedUserPreferences={receivedUserPreferences}
              />
            </List>
          </Collapse>
        </StyledMenuItem>
        <StyledMenuItem>
          <MessageCenter />
        </StyledMenuItem>
        <StyledMenuItem onClick={handleOpenChangePassword}>
          <ListItemText primary="Change Password" />
        </StyledMenuItem>
      </StyledMenu>

      {/* Change Password Dialog */}
      <Dialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Change Password</span>
            <MuiIconButton
              onClick={() => setChangePasswordOpen(false)}
              size="small"
            >
              <CloseIcon />
            </MuiIconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <ChangePasswordForm onClose={() => setChangePasswordOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
}

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    // '&:focus': {
    //      backgroundColor: theme.palette.primary.main,
    //      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //        color: theme.palette.common.white,
    //    },
    //},
  },
}))(MenuItem);
